const Header = () => {
    return (
        <header>
            <h1>💿 Music Mirror 💿</h1>
            <h2>Music Mirror on the wall, show me the likeness of them all?</h2>
        </header>
    )
}

export default Header;